import { initGtm } from '../gtm/GoogleTagManager.esm.js';
import Status from '../status/Status.esm.js';

let GTM = class GTM {
    init() {
        initGtm({
            id: this._id
        });
        return new Status(this, true);
    }
    sendEvent(data) {
        const dataLayerName = this['_dataLayerName'];
        return new Promise((resolve)=>{
            window[dataLayerName].push(Object.assign({
                event: data.event,
                eventCallback: ()=>{
                    resolve(new Status(this, true));
                },
                eventTimeout: 2000
            }, data.property));
        });
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get auth() {
        return this._auth;
    }
    set auth(value) {
        this._auth = value;
    }
    get preview() {
        return this._preview;
    }
    set preview(value) {
        this._preview = value;
    }
    get cookies_win() {
        return this._cookies_win;
    }
    set cookies_win(value) {
        this._cookies_win = value;
    }
    get dataLayerName() {
        return this._dataLayerName;
    }
    set dataLayerName(value) {
        this._dataLayerName = value;
    }
    get dataLayer() {
        return this._dataLayer;
    }
    set dataLayer(value) {
        this._dataLayer = value;
    }
    get events() {
        return this._events;
    }
    set events(value) {
        this._events = value;
    }
    constructor(id, auth, preview, cookies_win, dataLayerName, dataLayer, event){
        this.isActive = true;
        this._id = id;
        this._auth = auth;
        this._preview = preview;
        this._cookies_win = cookies_win;
        this._dataLayerName = dataLayerName;
        this._dataLayer = dataLayer;
        this._events = event;
    }
};

export { GTM as default };
